import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { TenantPassoCadastroResponse } from "../typings/header.data"

export function useDetalhesHeader() {
    return useQuery<TenantPassoCadastroResponse, AxiosError>('/v1/tenants/passos-cadastro', async () => {
        const { data } = await http.get<TenantPassoCadastroResponse>('/v1/tenants/passos-cadastro');

        return data;
    });
}
